<!-- one line (#173), as in the plain list; there the pager goes per location -->
<div class="top-controls">
    <div class="top-bar">
        <header-filters></header-filters>

        <single-choice
            class="bulk"
            [topic]="'multi-action'"
            [ticketId]="1"
            [editMode]="true"
            [locked]="!(hasSelection | async)"
            [completedUrl]="actionUrlObserver"
            [choiceObserver]="actionIdObserver"
            [icon]="'low_priority'"
            (choiceEvent)="relaySingleChoice($event)"
            [labelOnDemand]="actionLabelerByService"
            ></single-choice>

        <button class="plus" (click)="createTicket()">
            <i class="fa fa-plus" aria-hidden="true"></i>
        </button>
    </div>
</div>

<div class="accordion-container">
    <p-accordion [activeIndex]="activeBranchIndex" (onOpen)="onTabOpen($event)" (onClose)="onTabClose()">
        <p-accordionTab
            *ngFor="let branchId of branchIds; let i = index"
            [header]="branchName(branchId) + ' (' + branchTicketCount(branchId) + ')'"
            >
            <div class="table-container" *ngIf="getTickets(branchId).length > 0">
                <table>
                    <tbody>
                    <ticket-row
                        *ngFor="let ticket of getTickets(branchId)"
                        [ticket]="ticket"
                        [isSelectedFlag]="isSelected(ticket)"
                        [selectedTicket]="selectedTicket"
                        (selectToggled)="toggleSelect($event)"
                        (ticketClicked)="select($event)"
                        ></ticket-row>
                    </tbody>
                </table>
                <div class="pagination-info">
                    <div class="pagination-controls" *ngIf="getTotalPages(branchId) > 1">
                        <button
                            *ngFor="let page of getPaginationButtons(branchId)"
                            [disabled]="page === getCurrentPage(branchId) || page === '...'"
                            [class.gap]="page === '...'"
                            (click)="page !== '...' && goToPage(branchId, +page)"
                            >
                            {{ page === "..." ? "..." : +page + 1 }}
                        </button>
                    </div>
                    <span class="row-count">
                        {{ getStartRow(branchId) + 1 }}–{{ getEndRow(branchId) }} {{ 'pagination.of' | translate }} {{ branchTicketCount(branchId) }}
                    </span>
                </div>
            </div>

            <empty-details *ngIf="getTickets(branchId).length === 0"
                           title="empty.noTicketsInBranch"></empty-details>
        </p-accordionTab>
    </p-accordion>
</div>

<empty-details *ngIf="branchIds.length === 0"
               title="empty.noBranches"></empty-details>
